var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',{staticClass:"checkbox-container"},[_c('div',{class:{
        checkbox: true,
        checked: _vm.value,
        error: _vm.error,
        disabled: _vm.disabled
      },attrs:{"id":`${_vm.$attrs.id}_checkbox`}},[_c('div',{class:{
          ['checkbox-icon']: true,
          checked: _vm.value
        }},[_c('CheckedIcon',{attrs:{"width":"14","height":"14","fill":"white"}})],1)]),_vm._v(" "),(_vm.hasSlot)?_c('Spacer',{attrs:{"right":"xs"}}):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('input',_vm._b({staticClass:"checkbox-input",attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":_vm.handleChange}},'input',_vm.$attrs,false))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }